/**
 * Inicializador de Firebase Firestore y Auth
 * Configuración centralizada de la conexión a Firebase
 * Auth requerido para supplies/recipes (hasRole admin/gestor)
 */

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Configuración de Firebase (reemplazar con credenciales reales)
// TODO: Usar variables de entorno en producción
const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY || 'AIzaSyDemoKeyForDevelopment',
  authDomain: process.env.FIREBASE_AUTH_DOMAIN || 'faki-costos.firebaseapp.com',
  projectId: process.env.FIREBASE_PROJECT_ID || 'faki-costos-dev',
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET || 'faki-costos.appspot.com',
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || '123456789',
  appId: process.env.FIREBASE_APP_ID || '1:123456789:web:abcdef'
};

// Inicializar Firebase
let app;
let db;
let auth;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);
  console.log('✓ Firebase inicializado exitosamente');
} catch (error) {
  console.error('✗ Error inicializando Firebase:', error);
  auth = null;
}

export const isFirebaseReady = !!db;
export { app, db, auth };
